import "./TablesContentPanel.scss";

const TablesContentPanel = ({ kbase, workspaceId }) => {
  return <div className="tables_content_panel">Coming soon...</div>;
};

export default TablesContentPanel;
